/* eslint-disable react-hooks/exhaustive-deps */
// import CompanyFormNew from '@modules/admin/companies/Company.Form.New'
import CompanyFormNew2 from '@modules/admin/companies/Company.Form.New2'
import CompanyIntegrationForm from '@modules/admin/companies/Integration.Form'
import CompanyCommunicationForm from '@modules/admin/companies/Communication.Form'
import CompanyWelcomeMessageForm from '@modules/admin/companies/WelcomeMessage.Form'
import CompanyProtocolForm from '@modules/admin/companies/Protocol.From'
import CompanyModal from './Company.Modal'
import Consultations from '@services/Consultations'
import ConsultationsApiClient from '@services/Consultations'
import Customer from '@services/Customer'
import React, { useEffect, useState } from 'react'
import { history } from '@services/History'
import { withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { DashboardHeader } from '../Admin.Header'
import './Company.Create.scss'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'

const UpdateCompany = (props) => {
  const { t } = useTranslation()
  const [company, setCompany] = useState()

  const [companyFormData, setCompanyFormData] = useState()
  const [initialCompanyFormData, setInitialCompanyFormData] = useState()

  const [integrationFormData, setIntegrationFormData] = useState()
  const [initialIntegrationFormData, setInitialIntegrationFormData] = useState()

  const [welcomeMessageFormData, setWelcomeMessageFormData] = useState()
  const [initialWelcomeMessageFormData, setInitialWelcomeMessageFormData] = useState()

  const [communicationFormData, setCommunicationFormData] = useState()
  const [initialCommunicationFormData, setInitialCommunicationFormData] = useState()

  const [protocolFormData, setProtocolFormData] = useState()
  const [initialProtocolFormData, setInitialProtocolFormData] = useState()

  const [actualTabId, setActualTabId] = useState()
  const [nextTabEvent, setNextTabEvent] = useState()
  const [nextTabId, setNextTabId] = useState()

  const [showModal, setShowModal] = useState(false)
  const [specialities, setSpecialities] = useState()
  const [, setIsFetching] = useState(false)
  const companyClient = Consultations.company
  const companyConfigurationsClient = Customer.companyConfigurations
  const isUpdating = !window.location.pathname.split('/').includes('update') ? 'disabled' : false

  useEffect(() => {
    document.getElementById('companyTab').click()
    let companyId = props.match.params.companyId

    if (companyId) {
      setIsFetching(true)
      Promise.all([
        companyClient.show(Number(props.match.params.companyId)),
        companyConfigurationsClient.show(Number(props.match.params.companyId)),
      ])
        .then(([res, configurations]) => {
          setCompany({
            ...res.data,
            configurations: configurations.data,
          })
        })
        .catch((err) => {
          setCompany(undefined)
          window.alert(JSON.stringify(err.message, null, 2))
        })
        .finally(() => {
          setIsFetching(false)
        })
    }

    ConsultationsApiClient.speciality.index({ per_page: 1000 }).then((response) => {
      setSpecialities(response.data)
    })
  }, [])

  const checkCurrentTabChanges = () => {
    let hasUnsavedChanges
    switch (actualTabId) {
      case 'company':
        hasUnsavedChanges = checkUnsavedChanges(companyFormData, initialCompanyFormData)
        break
      case 'integration':
        hasUnsavedChanges = checkUnsavedChanges(integrationFormData, initialIntegrationFormData)
        break
      case 'communication':
        hasUnsavedChanges = checkUnsavedChanges(communicationFormData, initialCommunicationFormData)
        break
      case 'welcomeMessage':
        hasUnsavedChanges = checkUnsavedChanges(welcomeMessageFormData, initialWelcomeMessageFormData)
        break
      case 'protocol':
        hasUnsavedChanges = checkUnsavedChanges(protocolFormData, initialProtocolFormData)
        break

      default:
        hasUnsavedChanges = false
        break
    }

    return hasUnsavedChanges
  }

  const handleTabClick = (evt, tabId) => {
    setNextTabEvent(evt)
    setNextTabId(tabId)
    if (checkCurrentTabChanges()) {
      setShowModal(true)
    } else {
      openTab(evt, tabId)
    }
  }

  const openTab = (evt, tabId) => {
    let i, tabcontent, tablinks

    tabcontent = document.getElementsByClassName('tabcontent')

    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = 'none'
    }

    tablinks = document.getElementsByClassName('tablinks')
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(' active', '')
    }

    document.getElementById(tabId).style.display = 'block'
    evt.target.className += ' active'
    setActualTabId(tabId)
  }

  const checkUnsavedChanges = (formData, initialFormData) => {
    let isDirty = _.isEqual(formData, initialFormData)
    return !isDirty
  }
  const handleGobackButtonAction = () => {
    setNextTabId('')
    setShowModal(true)
  }

  const navigateToMediaNewTab = () => {
    const isProd = import.meta.env.VITE_REACT_APP_ENV === 'PRODUCTION'
    const url = isProd ? 'https://panel.meetingdoctors.com' : 'https://panel.staging.meetingdoctors.com'
    const companyId = props.match.params.companyId
    window.open(`${url}/main/companies/${companyId}/media`, '_blank')
  }

  return (
    <>
      <DashboardHeader title={t('updateCompany')}>
        {isUpdating ? (
          <Link className="btn btn-primary" to={`/companies/update/${company?.id}`}>
            {t('Editar')}
          </Link>
        ) : null}
        <button
          className="btn btn-primary"
          onClick={() => (checkCurrentTabChanges() ? handleGobackButtonAction() : history.goBack())}
        >
          {t('back')}
        </button>
      </DashboardHeader>

      <div className="container-fluid main-content">
        <div className="tab">
          <button className="tablinks" id="companyTab" onClick={(event) => handleTabClick(event, 'company')}>
            {t('dataAndServices')}
          </button>
          <button className="tablinks" id="integrationTab" onClick={(event) => handleTabClick(event, 'integration')}>
            {t('integrationsAndWebhooks')}
          </button>
          <button
            className="tablinks"
            id="communicatinoTab"
            onClick={(event) => handleTabClick(event, 'communication')}
          >
            {t('communication')}
          </button>
          <button className="tablinks" id="welcomeTab" onClick={(event) => handleTabClick(event, 'welcomeMessage')}>
            {t('welcomeMessage')}
          </button>
          <button className="tablinks" id="protocolTab" onClick={(event) => handleTabClick(event, 'protocol')}>
            {t('professionalProtocol')}
          </button>
          <button className="tablinks" id="protocolTab" onClick={navigateToMediaNewTab}>
            {t('companyMediaTab')}
          </button>
        </div>
        <fieldset disabled={isUpdating}>
          {showModal ? (
            <CompanyModal
              close={() => setShowModal(false)}
              onCancel={() => setShowModal(false)}
              onSave={(e) => {
                let isValid = document.querySelector(`#${actualTabId}-form`).reportValidity()

                if (isValid) {
                  document.getElementById(`${actualTabId}-submit-btn`).click()
                  if (nextTabId) {
                    openTab(nextTabEvent, nextTabId)
                  } else {
                    history.goBack()
                  }
                }
                setShowModal(false)
                setNextTabId('')
              }}
              onReset={() => {
                setShowModal(false)
                nextTabId ? openTab(nextTabEvent, nextTabId) : history.goBack()
                setNextTabId('')
              }}
            />
          ) : null}
          <div id="company" className="tabcontent">
            {company && specialities ? (
              <CompanyFormNew2
                company={company}
                specialities={specialities}
                formData={companyFormData}
                setFormData={setCompanyFormData}
                initialFormData={initialCompanyFormData}
                setInitialFormData={setInitialCompanyFormData}
              />
            ) : null}
          </div>
          <div id="integration" className="tabcontent">
            {company ? (
              <CompanyIntegrationForm
                company={company}
                formData={integrationFormData}
                setFormData={setIntegrationFormData}
                initialFormData={initialIntegrationFormData}
                setInitialFormData={setInitialIntegrationFormData}
              />
            ) : null}
          </div>
          <div id="communication" className="tabcontent">
            {company ? (
              <CompanyCommunicationForm
                company={company}
                formData={communicationFormData}
                setFormData={setCommunicationFormData}
                initialFormData={initialCommunicationFormData}
                setInitialFormData={setInitialCommunicationFormData}
              />
            ) : null}
          </div>
          <div id="welcomeMessage" className="tabcontent">
            {company && specialities ? (
              <CompanyWelcomeMessageForm
                company={company}
                specialities={specialities}
                formData={welcomeMessageFormData}
                setFormData={setWelcomeMessageFormData}
                initialFormData={initialWelcomeMessageFormData}
                setInitialFormData={setInitialWelcomeMessageFormData}
              />
            ) : null}
          </div>
          <div id="protocol" className="tabcontent">
            {company ? (
              <CompanyProtocolForm
                company={company}
                formData={protocolFormData}
                setFormData={setProtocolFormData}
                initialFormData={initialProtocolFormData}
                setInitialFormData={setInitialProtocolFormData}
                isUpdating={isUpdating}
              />
            ) : null}
          </div>
        </fieldset>
      </div>
    </>
  )
}

export default withTranslation()(UpdateCompany)
